/* facets.js — filtres, tri et tiroir de facettes « Tiitoune Aurum ».
   Pages collection et recherche : à chaque changement du formulaire
   [data-facets-form] (cases, prix débouncé, tri), la zone
   [data-collection-results] est re-rendue via la Section Rendering API
   (?section_id=…) puis l'URL est synchronisée (history.replaceState).
   Sans JS, le formulaire soumet nativement en GET (filtrage côté serveur).
   Vanilla JS, délégation d'événements sur document : aucun re-binding
   après re-rendu. Ré-exécution protégée par une garde window.*. */
(function () {
  'use strict';

  /* Garde anti double-exécution (éditeur de thème, scripts dupliqués) */
  if (window.__aurumFacets) return;
  window.__aurumFacets = true;

  var PRICE_DEBOUNCE = 400; /* ms — saisie des champs de prix */
  var priceTimer = null;
  var currentFetch = null;  /* AbortController de la requête en vol */
  var drawerOpen = false;   /* état du tiroir, conservé pendant les swaps */

  function noop() {}

  /* Racine de la zone filtrable (une seule par page : collection OU recherche) */
  function getRoot() {
    return document.querySelector('[data-collection-root]');
  }

  /* Re-scan des [data-reveal] re-rendus par le moteur d'animations */
  function engineRefresh(rootEl) {
    if (window.AurumEngine && typeof window.AurumEngine.refresh === 'function') {
      window.AurumEngine.refresh(rootEl);
    }
  }

  /* ------------------------------------------------------------------
     Tiroir de filtres (mobile, ou desktop si réglage « Tiroir »).
     Le rôle dialog n'est posé qu'à l'ouverture : en colonne latérale,
     le même markup reste un simple bloc statique.
     ------------------------------------------------------------------ */
  function getDrawerEl(rootEl) {
    return rootEl.querySelector('[data-facets-drawer]');
  }

  function syncToggle(rootEl, expanded) {
    var toggle = rootEl.querySelector('[data-facets-open]');
    if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function applyOpenState(rootEl) {
    var drawer = getDrawerEl(rootEl);
    if (!drawer) return;
    drawer.classList.add('is-open');
    var panel = drawer.querySelector('.facets__panel');
    if (panel) {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
    }
    syncToggle(rootEl, true);
  }

  function openDrawer(rootEl) {
    if (drawerOpen) return;
    applyOpenState(rootEl);
    drawerOpen = true;
    /* Verrou de défilement partagé (header.js / cart.js), si présent */
    if (window.AurumScrollLock) window.AurumScrollLock.acquire();
    var drawer = getDrawerEl(rootEl);
    var closeBtn = drawer && drawer.querySelector('.facets__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer(rootEl, refocus) {
    if (!drawerOpen) return;
    var drawer = getDrawerEl(rootEl);
    if (drawer) {
      drawer.classList.remove('is-open');
      var panel = drawer.querySelector('.facets__panel');
      if (panel) {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
      }
    }
    drawerOpen = false;
    if (window.AurumScrollLock) window.AurumScrollLock.release();
    syncToggle(rootEl, false);
    if (refocus) {
      var toggle = rootEl.querySelector('[data-facets-open]');
      if (toggle) toggle.focus();
    }
  }

  /* ------------------------------------------------------------------
     Préservation du focus pendant le swap : on mémorise le contrôle
     focalisé (nom + valeur), puis on re-focalise son équivalent dans le
     DOM frais (motif cart.js).
     ------------------------------------------------------------------ */
  function captureFocus(scope) {
    var active = document.activeElement;
    if (!active || !scope.contains(active)) return null;
    if (active.hasAttribute && active.hasAttribute('data-sort-select')) {
      return { kind: 'sort' };
    }
    if (active.name) {
      return {
        kind: 'control',
        name: active.name,
        value: active.value,
        isCheckbox: active.type === 'checkbox'
      };
    }
    return null;
  }

  function restoreFocus(scope, desc) {
    if (!desc) return;
    var el = null;
    if (desc.kind === 'sort') {
      el = scope.querySelector('[data-sort-select]');
    } else {
      /* Comparaison en JS (pas de sélecteur) : valeurs libres sans échappement */
      var candidates = scope.querySelectorAll('input[name], select[name]');
      for (var i = 0; i < candidates.length; i += 1) {
        if (candidates[i].name !== desc.name) continue;
        if (desc.isCheckbox && candidates[i].value !== desc.value) continue;
        el = candidates[i];
        break;
      }
    }
    if (el) el.focus({ preventScroll: true });
  }

  /* ------------------------------------------------------------------
     Requête Section Rendering API + swap de [data-collection-results]
     ------------------------------------------------------------------ */
  function render(rootEl, params) {
    var sectionId = rootEl.getAttribute('data-section-id');
    if (!sectionId) return;

    /* Une seule requête en vol : la plus récente gagne */
    if (currentFetch) currentFetch.abort();
    currentFetch = ('AbortController' in window) ? new AbortController() : null;

    var query = params.toString();
    var fetchUrl = window.location.pathname
      + '?section_id=' + encodeURIComponent(sectionId)
      + (query ? '&' + query : '');

    var live = rootEl.querySelector('[data-collection-results]');
    if (live) live.setAttribute('aria-busy', 'true');

    fetch(fetchUrl, currentFetch ? { signal: currentFetch.signal } : undefined)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-collection-results]');
        var liveNow = rootEl.querySelector('[data-collection-results]');
        if (!fresh || !liveNow) return;

        var wasOpen = drawerOpen;
        var focusDesc = captureFocus(liveNow);

        /* Swap du wrapper entier (grille + barre d'outils + facettes) */
        liveNow.innerHTML = fresh.innerHTML;
        liveNow.removeAttribute('aria-busy');

        /* Le tiroir était ouvert : on ré-applique l'état (le verrou de
           défilement, lui, n'a jamais été libéré) */
        if (wasOpen) applyOpenState(rootEl);

        restoreFocus(liveNow, focusDesc);

        /* URL propre (sans section_id) — partageable, retour arrière sain */
        var cleanUrl = window.location.pathname + (query ? '?' + query : '');
        window.history.replaceState({}, '', cleanUrl);

        engineRefresh(liveNow);
      })
      .catch(noop); /* abort / réseau : on garde l'affichage courant */
  }

  /* Sérialise le formulaire de facettes (FormData inclut les contrôles
     rattachés par l'attribut form="…", donc le <select> de tri) puis re-rend.
     Les valeurs vides sont écartées (URL propre). */
  function submitForm(form) {
    var rootEl = form.closest('[data-collection-root]') || getRoot();
    if (!rootEl) return;
    var data = new FormData(form);
    var params = new URLSearchParams();
    data.forEach(function (value, key) {
      if (String(value).length > 0) params.append(key, value);
    });
    render(rootEl, params);
  }

  /* ------------------------------------------------------------------
     Délégation d'événements — un seul binding par type, sur document
     ------------------------------------------------------------------ */

  /* Cases à cocher + tri (les champs de prix passent par l'input débouncé) */
  document.addEventListener('change', function (event) {
    var el = event.target;
    if (!el || !el.form || !el.form.hasAttribute || !el.form.hasAttribute('data-facets-form')) return;
    if (el.hasAttribute('data-facet-price')) return;
    submitForm(el.form);
  });

  /* Champs de prix : debounce 400 ms pendant la saisie */
  document.addEventListener('input', function (event) {
    var el = event.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-facet-price')) return;
    var form = el.form;
    if (!form || !form.hasAttribute('data-facets-form')) return;
    window.clearTimeout(priceTimer);
    priceTimer = window.setTimeout(function () {
      submitForm(form);
    }, PRICE_DEBOUNCE);
  });

  /* Soumission (Entrée dans un champ, bouton « Appliquer » si visible) */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-facets-form]')) return;
    event.preventDefault();
    submitForm(form);
  });

  /* Clics : ouverture/fermeture du tiroir + pastilles de retrait de filtre */
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-facets-open]');
    if (opener) {
      var rootOpen = opener.closest('[data-collection-root]');
      if (rootOpen) {
        event.preventDefault();
        if (drawerOpen) {
          closeDrawer(rootOpen, true);
        } else {
          openDrawer(rootOpen);
        }
      }
      return;
    }

    var closer = event.target.closest('[data-facets-close]');
    if (closer) {
      var rootClose = closer.closest('[data-collection-root]');
      if (rootClose) {
        event.preventDefault();
        closeDrawer(rootClose, true);
      }
      return;
    }

    /* Pastille « retirer ce filtre » / « Tout effacer » : on récupère les
       paramètres de l'URL du lien (générée par Shopify) et on re-rend */
    var pill = event.target.closest('[data-facet-remove]');
    if (pill) {
      var rootPill = pill.closest('[data-collection-root]');
      if (!rootPill) return; /* hors zone : navigation native */
      event.preventDefault();
      var url = new URL(pill.href, window.location.origin);
      render(rootPill, url.searchParams);
    }
  });

  /* Échap : fermeture du tiroir de filtres */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !drawerOpen) return;
    var rootEl = getRoot();
    if (rootEl) closeDrawer(rootEl, true);
  });

  /* Si la section est déchargée (éditeur de thème) avec le tiroir ouvert,
     on libère le verrou de défilement. */
  document.addEventListener('shopify:section:unload', function (event) {
    if (drawerOpen && event.target.querySelector('[data-facets-drawer]')) {
      drawerOpen = false;
      if (window.AurumScrollLock) window.AurumScrollLock.release();
    }
  });
})();
